

export const SAVE_UNIT_LOCATION = 'SAVE_UNIT_LOCATION';
export const GET_UNITS = 'GET_UNITS';

export interface ProcessUnitState {
    processUnitsLocations: any[];
    processUnits: any[];
}
